import { EChatActionModalActionTypes } from '../../actions/chatActionModal';
import { TAppState } from '../../types/appState';
import { TReduxActions } from '../../types/redux/actions';

export const chatActionModalReducer = (state: TAppState, action: TReduxActions): TAppState => {
  switch (action.type) {
    case EChatActionModalActionTypes.Open:
      return {
        ...state,
        chatActionModal: {
          isOpened: true,
          ...action.payload,
        },
      };

    case EChatActionModalActionTypes.Close:
      return {
        ...state,
        chatActionModal: {
          isOpened: false,
        },
      };

    default:
      return state;
  }
};
